import { RedirectConfig } from './api';

export interface UserClaims {
  clubCode: string;
  memberNumber?: string;
  customerId?: string;
}

/**
 * Substitutes placeholders in a string with actual values
 * Supports: [[clubCode]], [[memberNumber]], [[customerId]]
 * Case-insensitive matching
 */
export const substitutePlaceholders = (
  value: string,
  context: Record<string, string>
): string => {
  return value.replace(/\[\[(\w+)\]\]/g, (_, key) => {
    const lowerKey = key.toLowerCase();
    if (lowerKey === 'clubcode') return context.clubCode || '';
    if (lowerKey === 'membernumber') return context.memberNumber || '';
    if (lowerKey === 'customerid') return context.customerId || '';
    return context[key] || '';
  });
};

/**
 * Builds the final redirect URL from config and claims
 * @param config - The redirect configuration from API
 * @param claims - User claims for placeholder substitution
 * @returns The complete redirect URL
 */
export const buildRedirectUrl = (
  config: RedirectConfig,
  claims: UserClaims
): string => {
  const context: Record<string, string> = {
    clubCode: claims.clubCode,
    memberNumber: claims.memberNumber || '',
    customerId: claims.customerId || '',
  };

  // Build query string from params (already substituted by API, but handle any remaining)
  const params = new URLSearchParams();
  for (const [key, value] of Object.entries(config.params)) {
    const substitutedValue = substitutePlaceholders(value, context);
    params.append(key, substitutedValue);
  }

  const queryString = params.toString();
  // URL from API already ends with '?'
  return config.url + queryString;
};

/**
 * Performs the redirect to the destination URL
 */
export const performRedirect = (url: string): void => {
  window.location.href = url;
};
